import { render, staticRenderFns } from "./WaveForm.vue?vue&type=template&id=a3a5d956&scoped=true&"
import script from "./WaveForm.vue?vue&type=script&lang=js&"
export * from "./WaveForm.vue?vue&type=script&lang=js&"
import style0 from "./WaveForm.vue?vue&type=style&index=0&id=a3a5d956&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a5d956",
  null
  
)

export default component.exports